module.exports = __webpack_public_path__ + "static/media/pic7.f91bf8dc.jpg";